import LEGACY_ORG_FEATURES from '~/server_shared/generated-types/LEGACY_ORG_FEATURES';

import { isLegacyOrgFeatureEnabled } from '../../../Utils';

export function adjustColumnByClaim(columnData, claim, userOrganization) {
  if (['gl_claim', 'general_claim'].includes(claim.type)) {
    columnData = columnData.filter((col) => col.id !== 'mor');
  }

  if (claim.deductible_flow_type !== 'explicit') {
    columnData = columnData.filter((col) => col.id !== 'deductible');
  }

  if (['wc_claim'].includes(claim.type)) {
    columnData = columnData.filter((col) => col.id !== 'expenses_paid_sum' && col.id !== 'expenses_reserve');
    columnData.find((col) => col.id === 'indemnity_reserve').label = 'Reserve';
    columnData.find((col) => col.id === 'indemnity_paid_sum').label = 'Paid';
  }

  if (
    isLegacyOrgFeatureEnabled(userOrganization, LEGACY_ORG_FEATURES.HOSPITALITY_BOOST_CLAIM_LEVEL_COVERAGE_DECISION)
  ) {
    columnData = columnData.filter((col) => col.id !== 'coverage_decision');
  }

  return columnData;
}
